import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, AlertTriangle, Info } from 'lucide-react';
export function RepairOrReplace() {
  return <section className="py-16 lg:py-24 bg-slate-50 border-t border-slate-200" data-id="element-163">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-164">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-165">
          <h2 className="text-3xl md:text-4xl font-bold text-navy-900 mb-6" data-id="element-166">
            Should You Repair or Replace Your Windshield?
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 max-w-5xl mx-auto mb-12" data-id="element-167">
          {/* Repair Card */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="bg-white rounded-2xl p-8 shadow-md border border-slate-100 relative overflow-hidden" data-id="element-168">
            <div className="absolute top-0 left-0 w-full h-1 bg-emerald-500" data-id="element-169"></div>
            <div className="flex items-center gap-4 mb-6" data-id="element-170">
              <div className="w-12 h-12 bg-emerald-50 rounded-full flex items-center justify-center shrink-0" data-id="element-171">
                <CheckCircle2 className="w-6 h-6 text-emerald-600" data-id="element-172" />
              </div>
              <h3 className="text-2xl font-bold text-navy-900" data-id="element-173">
                Repair may be possible when…
              </h3>
            </div>
            <ul className="space-y-4" data-id="element-174">
              {['The chip is small and contained', "The damage is away from the driver's direct line of sight", 'The damage is not near the windshield edge', 'Dirt and moisture have not contaminated the damaged area'].map((bullet, i) => <li key={i} className="flex items-start gap-3" data-id="element-175">
                  <div className="w-1.5 h-1.5 rounded-full bg-emerald-500 mt-2.5 shrink-0" data-id="element-176"></div>
                  <span className="text-slate-700 text-lg" data-id="element-177">{bullet}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* Replace Card */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="bg-white rounded-2xl p-8 shadow-md border border-slate-100 relative overflow-hidden" data-id="element-178">
            <div className="absolute top-0 left-0 w-full h-1 bg-amber-500" data-id="element-179"></div>
            <div className="flex items-center gap-4 mb-6" data-id="element-180">
              <div className="w-12 h-12 bg-amber-50 rounded-full flex items-center justify-center shrink-0" data-id="element-181">
                <AlertTriangle className="w-6 h-6 text-amber-600" data-id="element-182" />
              </div>
              <h3 className="text-2xl font-bold text-navy-900" data-id="element-183">
                Replacement is usually safer when…
              </h3>
            </div>
            <ul className="space-y-4" data-id="element-184">
              {['The windshield has a crack', "Damage blocks or distorts the driver's view", 'Damage is near the edge of the glass', 'Multiple chips or spreading cracks are present', 'ADAS cameras or sensors may be affected'].map((bullet, i) => <li key={i} className="flex items-start gap-3" data-id="element-185">
                  <div className="w-1.5 h-1.5 rounded-full bg-amber-500 mt-2.5 shrink-0" data-id="element-186"></div>
                  <span className="text-slate-700 text-lg" data-id="element-187">{bullet}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>

        <div className="max-w-3xl mx-auto bg-blue-50/50 border border-blue-100 rounded-xl p-6 flex flex-col sm:flex-row items-start sm:items-center gap-4 mb-10" data-id="element-188">
          <Info className="w-6 h-6 text-brand-blue shrink-0" data-id="element-189" />
          <p className="text-sm text-slate-700 leading-relaxed" data-id="element-190">
            A chip repair is meant to help stop damage from spreading. It may
            still be visible after repair. Kosin's Glass can inspect the glass
            and explain the safest option.
          </p>
        </div>

        <div className="text-center" data-id="element-191">
          <a href="#quote" className="inline-flex items-center justify-center bg-white border-2 border-brand-blue text-brand-blue hover:bg-brand-light font-bold text-lg py-3 px-8 rounded-xl transition-colors" data-id="element-192">
            Request an Inspection
          </a>
        </div>
      </div>
    </section>;
}